<template>
  <!-- comment-item -->
  <section>
    <div class="flex-box parent-comment" :class="{ clicked: isClickedComment}">
      <span class="info-userimg">
        <router-link :to="{ name: 'User', params: { userId: propComment.userId }}">
          <img v-if="getUserInfoById(propComment.userId).userIcon" :src="getUserInfoById(propComment.userId).userIcon" alt="image" class="img-circle">
          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
        </router-link>
      </span>
      <div class="comment detail-head">
        <div class="info-userelement">
          <span class="info-username">{{ getUserInfoById(propComment.userId).userName }}</span>
          <span class="info-time">
            {{propComment.createdAt | preparedTime}}
          </span>
        </div>
        <div v-if="propComment.isDelete">{{ getContentText }}</div>
        <div v-else-if="propComment.isStamp" class="show-stamp">
          <img :src="getStampImg(propComment.isStamp)" :alt="propComment.isStamp">
        </div>
        <!-- {{propComment.id}} -->
        <read-more v-else :targetId="propComment.id" :isGrayOut="!!propComment.isDelete" :text="getContentText" :addMore="isDetail" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">
          {{ getContentText }}
        </read-more>
        <span v-if="propComment.uploadedFile" class="image-add">
          <b-row>
            <b-col>
              <div class="uploaded-images" v-viewer="{
                button: true,
                navbar: false,
                title: false,
                toolbar: true,
                tooltip: true,
                movable: true,
                zoomable: true,
                rotatable: true,
                scalable: false,
                transition: true,
                fullscreen: true,
                keyboard: false }" @click.stop>
                <img :src="propComment.uploadedFile">
              </div>
            </b-col>
          </b-row>
        </span>
        <div class="child-tools" v-if="!isManage">
          <span class="info-menu">
            <a @click="onClickReply('parent', propComment.id)" class="info-comment-detail collapse-reply">
              <i class="fa fa-mail-reply fa-rotate-180"></i>
            </a>
          </span>
          <span v-if="checkCommentIsDelete(propComment)" class="info-right">
            <comment-drop-down @comment-delete="commentDelete(propComment, 'parent')"/>
          </span>
        </div>
      </div>
    </div>
    <div v-for="child in getChildComments" v-if="isShowChild" :key="child.id" class="flex-box child-comments" :class="{clicked: child.id === clickedCommentId}">
      <child-comment-item :propChildComment="child" @call-set-reply="onCallClickReply"/>
      <!--
        <span v-if="obj.uploadedFile" class="image-add">
          <b-row>
            <b-col>
              <div class="uploaded-images" v-viewer="{
                button: true,
                navbar: false,
                title: false,
                toolbar: true,
                tooltip: true,
                movable: true,
                zoomable: true,
                rotatable: true,
                scalable: false,
                transition: true,
                fullscreen: true,
                keyboard: false }" @click.stop>
                <img :src="obj.uploadedFile">
              </div>
            </b-col>
          </b-row>
        </span>
        <div class="child-tools">
          <span class="info-menu">
            <a @click="onClickReply(obj, obj.id)" class="info-comment-detail collapse-reply">
              <i class="fa fa-mail-reply fa-rotate-180"></i>
            </a>
          </span>
          <span v-if="checkCommentIsDelete(obj)" class="info-right">
            <comment-drop-down @comment-delete="commentDelete(obj, 'child')"/>
          </span>
        </div>
      </div>
      -->
    </div>
  </section>
  <!-- /comment-item -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CommentDropDown from '@/components/Comment/CommentDropDown'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import moment from 'moment'
import ChildCommentItem from '@/components/Comment/ChildCommentItemInManage'
import 'viewerjs/dist/viewer.css'
import { stampsurl } from '@/main'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)

export default {
  name: 'CommentItem',
  props: {
    propComment: Object,
    isManage: {
      type: Boolean,
      default: false
    },
    isShowChild: {
      type: Boolean,
      default: true
    },
    isDetail: {
      type: Boolean,
      default: true
    },
    isClickedComment: {
      type: Boolean,
      default: false
    },
    clickedCommentId: {
      type: String,
      default: ''
    }
  },
  components: {
    CommentDropDown,
    ReadMore,
    ChildCommentItem
  },
  data () {
    return {
      options: {
        showCounter: false,
        widthRatio: 0.5,
        heightRatio: 0.5,
        nav: false,
        close: false
      },
      propShowMore: false,
      propContentHeight: 0,
      childShowMore: false,
      childContentHeight: 0
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('comments/', [
      'getChildCommentsByParentId'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    getChildComments () {
      return this.getChildCommentsByParentId(this.propComment.id, this.propComment.target)
    },
    getContentText () {
      if (!this.propComment.isDelete) {
        return this.propComment.contentText
      } else {
        return this.$t('deletedComentStr')
      }
    }
  },
  mounted: function () {
    console.log('CommentItemInManage:moutned', this.clickedCommentId)
  },
  updated: function () {
    console.log(this.propComment.userId)
  },
  methods: {
    ...mapActions('comments/', {
      removeCommnet: 'REMOVE_COMMENT'
    }),
    checkCommentIsDelete: function (comment) {
      if (comment.userId === this.getUserId && !comment.isDelete) {
        return true
      } else {
        return false
      }
    },
    onCallClickReply: function (value) {
      const parentItem = value
      console.log('parentItem::::', parentItem)
      this.onClickReply(parentItem.item, parentItem.id)
    },
    onClickReply: function (value, itemId) {
      let parentItem
      if (value === 'parent') {
        parentItem = {
          item: this.propComment,
          id: itemId
        }
        this.$emit('set-reply', parentItem)
      } else {
        parentItem = {
          item: value,
          id: itemId
        }
        this.$emit('set-reply', parentItem)
      }
    },
    commentDelete: function (comment, string) {
      // console.log('commentDelete', parentId)
      // console.log('commentId', this.propComment.id)
      let deleteInfo = {}
      // console.log(comment)
      // if (string === 'child') {
      //   deleteInfo = {
      //     parentId: comment.parentId,
      //     commentId: comment.id,
      //     targetId: comment.targetId,
      //     target: comment.target,
      //     userId: comment.userId
      //   }
      // } else {
      console.log(this.getChildCommentsByParentId(comment.id, comment.target))
      if (this.getChildCommentsByParentId(comment.id, comment.target).length > 0) {
        deleteInfo = {
          parentId: 'parent',
          commentId: comment.id,
          targetId: comment.targetId,
          target: comment.target,
          userId: comment.userId,
          targetOwner: comment.targetOwner,
          remtext: this.$t('deletedComentStr')
        }
      } else {
        deleteInfo = {
          parentId: 'notParent',
          commentId: comment.id,
          targetId: comment.targetId,
          target: comment.target,
          userId: comment.userId,
          targetOwner: comment.targetOwner,
          remtext: this.$t('deletedComentStr')
        }
      }
      // }
      if (comment.uploadedFile) {
        console.log('deleteInfo add deleteimage')
        deleteInfo.uploadedFile = comment.uploadedFile
      }
      // console.log('hoge', deleteInfo)
      this.removeCommnet(deleteInfo)
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      // console.log('in comment updateContentHeight::', value)
      this.propContentHeight = value
    },
    updateChildShowMore: function (value) {
      this.childShowMore = value
    },
    updateChildContentHeight: function (value) {
      // console.log('in comment updateContentHeight::', value)
      this.childContentHeight = value
    },
    getStampImg (key) {
      var url = stampsurl.host + '/stamp/' + key
      return url
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    },
    momentDay: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentTime: function (date) {
      return moment(date).format('HH:mm:ss')
    }
  }
}
</script>
<style scoped>
.parent-comment {
  padding-bottom: 10px;
}
.clicked{
  border-color: #F0E0E0;
  border-style: solid;
  border-width: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Comment/CommentItemInManage.vue